<template>
  <div>
    <b-row>
      <b-col cols="6">
        <FITTextInput :label="$t('osm.contents.lifePolicy.generalInformation.productName')" :width="8" type="text" :disabled="true" :value="detail.productEnglishName + detail.productChineseName"></FITTextInput>
        <FITTextInput :label="$t('osm.contents.lifePolicy.generalInformation.modalPremium')" :width="8" type="text" v-model="value.modalPremium"></FITTextInput>
        <FITDatePicker :label="$t('osm.renewal.renewLife.actualPaymentDate')" v-model="value.actualPaymentDate" :width="8"></FITDatePicker>
      </b-col>
      <b-col cols="6">
        <FITTextInput :label="$t('osm.contents.lifePolicy.generalInformation.policyNumber')" v-model="detail.policyNumber" :width="8" type="text" :disabled="true"></FITTextInput>
        <FITTextInput :label="$t('osm.renewal.renewLife.period')" :width="8" type="number" v-model="value.period"></FITTextInput>
      </b-col>
      <b-col cols="6">
        <FITSelect :label="$t('osm.contents.lifePolicy.generalInformation.paymentMethod')" :width="8" :options="getTranslated(`${$i18n.locale}`,'Renewal','paymentMethod')" v-model="value.paymentMethod"></FITSelect>
        <!--                   <FITSelect :label="$t('osm.contents.lifePolicy.generalInformation.companyBank')" :width="8" :options="getTranslated(`${$i18n.locale}`,'Renewal','companyBank')" v-model="form.companyBank"></FITSelect> -->
      </b-col>
      <b-col cols="6">
        <FITTextInput :label="$t('osm.contents.lifePolicy.generalInformation.paymentReference')" v-model="value.paymentReference" :width="8" type="text"></FITTextInput>
      </b-col>
    </b-row>
  </div>
</template>
<script type="text/javascript">
import { mapGetters } from 'vuex'
import { FITFormCard, FITTextInput, FITTextarea, FITButton, FITModal, FITAutoSearch, FITSelect, FITDatePicker } from '@/components'

export default {
  name: 'RenewLifeComponent',
  components: {
    FITFormCard,
    FITTextInput,
    FITTextarea,
    FITButton,
    FITModal,
    FITAutoSearch,
    FITSelect,
    FITDatePicker
  },
  props: {
    detail: {
      type: Object,
      default: {},
    },
    value: {
      type: Object
    }
  },
  computed: {
    ...mapGetters(['getTranslated']),
  },
}

</script>



// WEBPACK FOOTER //
// src/Osm/Renewal/components/RenewLifeComponent.vue